import { render } from "./cliente-dropdown.vue?vue&type=template&id=387f0fbc&scoped=true"
import script from "./cliente-dropdown.vue?vue&type=script&lang=js"
export * from "./cliente-dropdown.vue?vue&type=script&lang=js"

import "./cliente-dropdown.vue?vue&type=style&index=0&id=387f0fbc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387f0fbc"]])

export default __exports__